import { render, staticRenderFns } from "./PromotionSection.vue?vue&type=template&id=dad4fdc4&"
import script from "./PromotionSection.vue?vue&type=script&lang=js&"
export * from "./PromotionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports